import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SeoService } from '../../../service/seo.service';

@Component({
    selector: 'app-export-internazionalizzazione',
    templateUrl: './export-internazionalizzazione.component.html',
    standalone: false
})
export class ExportInternazionalizzazioneComponent implements OnInit {

    constructor(private router: Router, private seoService: SeoService) { }

    ngOnInit(): void {
        const h2Text = "Sostieni la tua internazionalizzazione: fondo SIMEST 394 per export PMI, Temporary Export Manager e contributi per fiere estere";
        
        this.seoService.updateSeo({
            titleSeo: "Bandi Export & Internacionalizzazione – PMI | Innovation Plaza",
            metadescription: h2Text
        });
    }

    goTo(route: string){		 
        this.router.navigate([route])
    }

}